var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    {
      staticClass: "modal modal-filter-details fade",
      attrs: {
        id: "add-tag-talent",
        role: "dialog",
        "aria-labelledby": "location-label",
        "aria-hidden": "true",
      },
    },
    [
      _c("div", { staticClass: "modal-dialog" }, [
        _c("div", { staticClass: "modal-content" }, [
          _c("div", { staticClass: "modal-header" }, [
            _c("h4", { staticClass: "modal-title" }, [
              _vm._v(
                "\n          Add " +
                  _vm._s(_vm._f("sentenceCase")(_vm.$starLabelPlural)) +
                  " to " +
                  _vm._s(_vm.tag.name) +
                  "\n          "
              ),
              _vm._m(0),
            ]),
          ]),
          _vm._v(" "),
          _c("div", { staticClass: "modal-body" }, [
            _c(
              "div",
              [
                _c("div", { staticClass: "row" }, [
                  _c("div", { staticClass: "col-lg-12" }, [
                    _c("div", { staticClass: "form-group" }, [
                      _c("p", { staticClass: "sub-head" }, [
                        _vm._v("Filter Talent – "),
                        _c("span", [_vm._v(_vm._s(_vm.pagination.total))]),
                        _vm._v(" Found"),
                      ]),
                    ]),
                  ]),
                ]),
                _vm._v(" "),
                _c("div", { staticClass: "row" }, [
                  _c("div", { staticClass: "col-sm-12" }, [
                    _c("div", { staticClass: "input-group" }, [
                      _c("input", {
                        directives: [
                          {
                            name: "model",
                            rawName: "v-model",
                            value: _vm.keywords,
                            expression: "keywords",
                          },
                        ],
                        staticClass: "form-control",
                        attrs: {
                          type: "text",
                          placeholder:
                            _vm.$options.filters.sentenceCase(_vm.$starLabel) +
                            " Name...",
                        },
                        domProps: { value: _vm.keywords },
                        on: {
                          keyup: function ($event) {
                            if (
                              !$event.type.indexOf("key") &&
                              _vm._k(
                                $event.keyCode,
                                "enter",
                                13,
                                $event.key,
                                "Enter"
                              )
                            )
                              return null
                            return _vm.getTalent.apply(null, arguments)
                          },
                          input: function ($event) {
                            if ($event.target.composing) return
                            _vm.keywords = $event.target.value
                          },
                        },
                      }),
                      _vm._v(" "),
                      _c(
                        "span",
                        { staticClass: "input-group-btn" },
                        [
                          _c(
                            "ladda-button",
                            {
                              ref: "search",
                              staticClass: "btn btn-dark",
                              attrs: { type: "submit", click: _vm.getTalent },
                            },
                            [
                              _vm._v(
                                "\n                    Search\n                  "
                              ),
                            ]
                          ),
                        ],
                        1
                      ),
                    ]),
                  ]),
                ]),
                _vm._v(" "),
                _c("div", { staticClass: "row m-t-xs m-b-xs" }, [
                  _c("div", { staticClass: "col-lg-12" }, [
                    _c(
                      "a",
                      {
                        staticClass: "cursor-pointer pull-right",
                        on: {
                          click: function ($event) {
                            return _vm.handleClearFilter()
                          },
                        },
                      },
                      [_c("span", [_vm._v("Clear Filter")])]
                    ),
                  ]),
                ]),
                _vm._v(" "),
                _c("br"),
                _vm._v(" "),
                _c(
                  "div",
                  { staticClass: "row row-results" },
                  _vm._l(_vm.talent, function (t) {
                    return _c(
                      "div",
                      { key: t.id, staticClass: "col-xs-6 col-sm-4" },
                      [
                        _c("system-tag-management-talent-list-item", {
                          attrs: { talent: t },
                          on: {
                            removeTagTalent: _vm.removeTagTalent,
                            addTagTalent: _vm.addTagTalent,
                          },
                        }),
                      ],
                      1
                    )
                  }),
                  0
                ),
                _vm._v(" "),
                _vm.talent.length === 0
                  ? _c("div", { staticClass: "text-center" }, [
                      _c("h5", [
                        _vm._v(
                          "Couldn't find any " +
                            _vm._s(_vm.$starLabelPlural) +
                            ". Please check search credentials and try again."
                        ),
                      ]),
                    ])
                  : _vm._e(),
                _vm._v(" "),
                _c(
                  "lazy-loading",
                  {
                    ref: "lazyLoading",
                    staticClass: "text-center m-b-md",
                    attrs: {
                      "scroll-target": "#add-tag-talent .modal-body",
                      loading: _vm.fetching,
                      "reached-bottom": _vm.getNextTalent,
                    },
                  },
                  [
                    _c("div", {
                      staticClass: "pickstar-loading",
                      attrs: { slot: "loading" },
                      slot: "loading",
                    }),
                    _vm._v(" "),
                    _c("span", {
                      attrs: { slot: "finished" },
                      slot: "finished",
                    }),
                  ]
                ),
              ],
              1
            ),
          ]),
          _vm._v(" "),
          _vm._m(1),
        ]),
      ]),
    ]
  )
}
var staticRenderFns = [
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c(
      "button",
      {
        staticClass: "close",
        attrs: {
          type: "button",
          "data-dismiss": "modal",
          "aria-label": "Close",
        },
      },
      [_c("span", { attrs: { "aria-hidden": "true" } }, [_vm._v("×")])]
    )
  },
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("div", { staticClass: "modal-footer" }, [
      _c(
        "button",
        {
          staticClass: "btn btn-lg btn-primary pull-right",
          attrs: { type: "button", "data-dismiss": "modal" },
        },
        [_c("i", { staticClass: "fa fa-check" }), _vm._v(" Done")]
      ),
    ])
  },
]
render._withStripped = true

export { render, staticRenderFns }